import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { supportConnectionSelector } from '../../auth/selectors/authSelectors';
import { connectToSupportVPNRequest, getSupportConnectionRequest } from '../../auth/actions/authActions';
import VPNStatus from '../components/VPNStatus/VPNStatus';

const mapStateToProps = createStructuredSelector({ supportConnection: supportConnectionSelector });
const mapDispatchToProps = {
    getSupportConnectionRequest,
    connectToSupportVPNRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(VPNStatus);
